import React from 'react'

export const CalenderIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.333 2.166v3.333M6.667 2.166v3.333M2.5 8.833h15m-13.333-5h11.666c.92 0 1.667.746 1.667 1.666v11.667c0 .92-.746 1.667-1.667 1.667H4.167c-.92 0-1.667-.746-1.667-1.667V5.499c0-.92.746-1.666 1.667-1.666z" stroke="#667085" strokeWidth="1.667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}
